module.exports = __webpack_public_path__ + "static/media/Asset-25.5cf2584d.png";